import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPublicPage } from "./publicPages";

const privateRoutePatterns = [
  /^\/(?:signup|email-verification|change-temporary-password|login)(?:\/|$)/,
  /^\/forgot-password(?:\/|$)/,
  /^\/auth(?:\/|$)/,
  /^\/(?:dashboard|user-dashboard|customers|suppliers|inventory|materials|production|settings|sales|sales-returns|payments|purchases|purchase-returns|expenses|reports|subscription)(?:\/|$)/,
  /^\/staff(?:\/|$)/,
  /^\/superadmin(?:\/|$)/,
];

export default function PrivateRouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (getPublicPage(pathname) || !privateRoutePatterns.some((pattern) => pattern.test(pathname))) return;
    document.title = pathname === "/login" ? "Log in | FIRMAFLOW" : pathname === "/signup" ? "Create an account | FIRMAFLOW" : "FIRMAFLOW Application";
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "noindex, nofollow, noarchive";
    document.head.querySelector('link[rel="canonical"]')?.remove();
    document.querySelectorAll('script[data-firmaflow-schema]').forEach((node) => node.remove());
  }, [pathname]);

  return null;
}
